module.exports = __webpack_public_path__ + "static/media/comment-medical.1aa3e226.svg";